// Pure helpers for the showcase section. No React, no side effects.

export const sortByFeaturedOrder = (list) =>
  [...list].sort((a, b) => (a.featured_order ?? 0) - (b.featured_order ?? 0));

export const getFeaturedProjects = (projects) =>
  sortByFeaturedOrder(projects.filter((p) => p.featured_order != null));

export const filterByCategory = (projects, category) => {
  if (category === "All") return projects;
  if (category === "Coming Soon") return projects.filter((p) => p.status === "open");
  return projects.filter(
    (p) => p.category === category || (p.tags && p.tags.includes(category))
  );
};

export const stripScheme = (url) => (url ? url.replace(/^https?:\/\//, "") : "");
